import { SetItemAsync } from "./SetItemAsync"

export const setAsync: SetItemAsync = async (key, value) => {
  return localStorage.setItem(key, value)
}
